import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { SubscriptionList } from '../../models/SubscriptionList';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { ResponsiveContainer } from 'recharts';

import { donutchartConfig } from './surfamountdonutchart_config'; //config

/// <reference types="@types/recharts/index.d.ts" />

//css
const donutChartStyle = require('./surfamountdonutchart.css');


//Props
interface Props {
  // subscription: typeof Subscription.Type;
  subscriptionList: typeof SubscriptionList.Type;
}

@observer
export default class SurfAmountDonutChart extends React.Component<{ subscriptionList: typeof SubscriptionList.Type }> {

  valueShortStr = (value) => {
    let numstr: string = '0,0';
    if (value > 0) {
      let num = Math.round(value * 10) / 10; //ex 3,56 becomes 3,6(36/10)
      numstr = num.toFixed(1);
      numstr.replace(/\./g, ','); //replace . with ,                
    }
    return (
      numstr + ' GB'
    );
  }

  customTooltip = (props) => {
    if (props.active) {
      if (props.payload.length > 0) {
        return (

          <div className="custom-tooltip">
            {/* <p className="desc">{props.payload[0].name} : {props.payload[0].value}.</p> */}
            <p>{props.payload[0].name} : {this.valueShortStr(props.payload[0].value)}</p>

          </div>
        );
      } else {
        return (
          <div className="custom-tooltip">
            <p className="desc">Empty data.</p>
          </div>
        );
      }
    } else {
      return <p className="desc">Not active.</p>;
    }
  }


  render() {

    //data
    let data: { name: string, value: number }[] = [];
    data.push({ name: 'Använt', value: this.props.subscriptionList.selectedSubscription.surfAmount.usedData });
    data.push({ name: 'Kvar', value: this.props.subscriptionList.selectedSubscription.surfAmount.leftData });

    //data Key
    let dataKey: string = 'value';

    //data colors
    let datacolors: { name: string, value: string }[] = [];
    datacolors.push({ name: 'Använt', value: '#F24962' }); //Tellit coral
    datacolors.push({ name: 'Kvar', value: '#FFFFFF' }); //white

    //middle text
    let pietext1: string = 'Använt';
    let pietext2: string = this.props.subscriptionList.selectedSubscription.surfAmount.usedDataOneDecimalString + ' GB'; //'4.1 GB';
    let pietext3: string = 'av ' + this.props.subscriptionList.selectedSubscription.surfAmount.initData + ' GB' + ' surf'; //'av 16 GB surf';


    return (
      <ResponsiveContainer width="100%" aspect={2}>
        <PieChart
          margin={donutchartConfig.piechartMargin} //{{top: 10, right: 10, left: 10, bottom: 10}}
        >
          <text x={'50%'} y={'50%'} textAnchor="middle" dominantBaseline="middle" className="piemiddletext normalsize">
            <tspan x={'50%'} y={donutchartConfig.middletext1Y} className="piemiddletext italic normalsize" alignmentBaseline="middle">{pietext1}</tspan>
            <tspan x={'50%'} y={donutchartConfig.middletext2Y} className="piemiddletext bold largesize" alignmentBaseline="middle">{pietext2}</tspan>
            <tspan x={'50%'} y={donutchartConfig.middletext3Y} className="piemiddletext italic normalsize" alignmentBaseline="middle">{pietext3}</tspan>
          </text>

          <Pie
            data={data}
            dataKey={dataKey}
            startAngle={90}
            endAngle={-270}
            innerRadius={donutchartConfig.pieInnerRadius} //{'77%'}
            outerRadius={donutchartConfig.pieOuterRadius} //{'99%'}
            labelLine={false}
          >
            {
              data.map((entry, index) =>
                <Cell fill={datacolors[index].value} />)
            }

          </Pie>
          {/* <Tooltip/>             */}
          <Tooltip content={this.customTooltip} />
        </PieChart>
      </ResponsiveContainer>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/surfamountdonutchart/SurfAmountDonutChart.tsx